import apiClient from '../common/apiClient';

export default class LogoutController {
  async Logout(data) {
    try {
      return await apiClient.post('/logout', JSON.stringify(data), {
        headers: {
          Authorization: `Bearer ${data.User}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
}
